import React from 'react';
import Container from 'react-bootstrap/Container';
import CustomMaterialForm from '../../components/Forms/CustomMaterialForm';

const Requests = () => {
	return (
		<Container className='py-5 px-3'>
			<div className='text-center mb-4'>
				<h1 className='fw-bold' style={{ color: '#384971' }}>
					Request Custom Materials
				</h1>
				<p className='text-muted'>
					Use this form to request sheet music, backing tracks, or
					full packages tailored to your audition or performance
					needs.
					<br />
					<small>
						Typical pricing starts at $25 –{' '}
						<a href='#pricing'>see details</a>
					</small>
				</p>
			</div>
			<div className='mx-auto' style={{ maxWidth: '700px' }}>
				<CustomMaterialForm />
			</div>
			<div id='pricing' className='text-center mt-5'>
				<h5 className='fw-bold' style={{ color: '#384971' }}>
					Typical Pricing
				</h5>
				<ul
					className='list-unstyled'
					style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
					<li>
						<strong>
							Sheet Music (cut, formatting, or preparation):
						</strong>{' '}
						$15–$25
					</li>
					<li>
						<strong>Custom Backing Track:</strong> $20–$50 (includes
						reference track; varies by difficulty)
					</li>
					<li>
						<strong>Learning Track for outside material:</strong>{' '}
						$30–$60
					</li>
					<li>
						<strong>Rush Turnaround (under 48 hrs):</strong> +$20
					</li>
				</ul>
				<p className='text-muted' style={{ fontSize: '0.95rem' }}>
					Final price depends on the complexity of your request. We'll
					confirm cost with you before starting — no surprises!
					<br />
					<br />
					Need us to create a custom cut or backing track? We can work
					with existing materials or create new ones as needed.
					<br />
					Final pricing may vary based on whether you provide sheet
					music or need it sourced or prepared.
				</p>
				<small
					className='text-muted d-block mt-3'
					style={{ fontSize: '0.85rem' }}>
					We comply with U.S. copyright law. All custom work is
					created for educational or audition use only. Clients are
					responsible for securing appropriate performance rights if
					needed.
				</small>
				<small
					className='text-muted d-block'
					style={{ fontSize: '0.85rem' }}>
					Submitting a request does not guarantee fulfillment. We will
					confirm all details and pricing before starting any work.
				</small>
				<small
					className='text-muted d-block'
					style={{ fontSize: '0.85rem' }}>
					By submitting this form, you agree to our{' '}
					<a href='/terms'>Terms of Service</a>.
				</small>
			</div>
		</Container>
	);
};

export default Requests;
